var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useStorage, createAction } from 'master-hook';
import { client } from '../services';
export var makeActions = function (storageName, name, res) {
    var c = client.crud(name);
    var getList = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (_a) {
            var items;
            var _b;
            var _c = _a === void 0 ? {} : _a, filters = _c.filters, paging = _c.paging, sorting = _c.sorting, category = _c.category;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        items = client.all;
                        if (res === null || res === void 0 ? void 0 : res.list) {
                            items = __assign(__assign({}, client.all), res.list);
                        }
                        return [4 /*yield*/, client.query((_b = {}, _b[c.list] = __assign(__assign({}, client.all), { counters: client.all, items: items, __args: { filters: filters, paging: paging, sorting: sorting, category: category } }), _b))];
                    case 1: return [2 /*return*/, (_d.sent())[c.list]];
                }
            });
        });
    };
    var getActions = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (ids) {
            var _a;
            if (ids === void 0) { ids = []; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, client.query((_a = {},
                            _a[c.actions] = {
                                __args: { ids: ids },
                            },
                            _a))];
                    case 1: return [2 /*return*/, (_b.sent())[c.actions]];
                }
            });
        });
    };
    var getItem = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var item;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    item = client.all;
                    if (res === null || res === void 0 ? void 0 : res.item) {
                        item = __assign(__assign({}, client.all), res.item);
                    }
                    return [4 /*yield*/, client.query((_a = {},
                            _a[c.one] = __assign(__assign({}, item), { __args: { id: Number(id) } }),
                            _a))];
                case 1: return [2 /*return*/, (_b.sent())[c.one]];
            }
        });
    }); };
    var updateItem = function (id, data) { return __awaiter(void 0, void 0, void 0, function () {
        var item;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    item = client.all;
                    if (res === null || res === void 0 ? void 0 : res.item) {
                        item = __assign(__assign({}, client.all), res.item);
                    }
                    return [4 /*yield*/, client.mutation((_a = {},
                            _a[c.update] = __assign(__assign({}, item), { __args: { id: Number(id), data: data } }),
                            _a))];
                case 1: return [2 /*return*/, (_b.sent())[c.update]];
            }
        });
    }); };
    var getLc = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (ids, action, data) {
            var nameAction, args;
            var _a;
            if (ids === void 0) { ids = []; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        nameAction = c.lc(action);
                        args = { ids: ids.map(function (id) { return Number(id); }) };
                        if (data) {
                            args.data = data;
                        }
                        return [4 /*yield*/, client.mutation((_a = {},
                                _a[nameAction] = {
                                    count: true, succeed: true, failed: true,
                                    __args: args
                                },
                                _a))];
                    case 1: return [2 /*return*/, (_b.sent())[nameAction]];
                }
            });
        });
    };
    var actions = {};
    // Load items
    actions.getList = getList;
    actions.loadList = createAction(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (definedFilters) {
            var _a, _b, filters, paging, sorting, category, listBeforeLoad, setList, isInitList, setIsInitList, setIsLoadingList, filtersWithoutSkip, filtersForApi, listResponse;
            var _c, _d;
            if (definedFilters === void 0) { definedFilters = {}; }
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = useStorage(storageName), _b = _a.filters, filters = _b === void 0 ? {} : _b, paging = _a.paging, sorting = _a.sorting, category = _a.category, listBeforeLoad = _a.list, setList = _a.setList, isInitList = _a.isInitList, setIsInitList = _a.setIsInitList, setIsLoadingList = _a.setIsLoadingList;
                        if (!getList) {
                            return [2 /*return*/, undefined];
                        }
                        if (typeof window !== 'undefined' && window.__IOMART_DEBUG_LIST__) {
                            // В консоли: window.__IOMART_DEBUG_LIST__ = true
                            console.log('[loadList:start]', {
                                storageName: storageName,
                                category: category,
                                page: paging === null || paging === void 0 ? void 0 : paging.page,
                                itemsBefore: (_c = listBeforeLoad === null || listBeforeLoad === void 0 ? void 0 : listBeforeLoad.items) === null || _c === void 0 ? void 0 : _c.length,
                            });
                        }
                        setIsLoadingList(true);
                        filtersWithoutSkip = Object.fromEntries(Object.entries(filters).filter(function (_a) {
                            var key = _a[0], value = _a[1];
                            return !(value === null || value === void 0 ? void 0 : value._skip);
                        }));
                        filtersForApi = Object.fromEntries(Object.entries(__assign(__assign({}, definedFilters), filtersWithoutSkip)).filter(function (_a) {
                            var key = _a[0];
                            return !key.endsWith('_display');
                        }));
                        return [4 /*yield*/, getList({
                                filters: filtersForApi,
                                paging: paging,
                                sorting: sorting,
                                category: category,
                            })];
                    case 1:
                        listResponse = _e.sent();
                        if (listResponse === null || listResponse === void 0 ? void 0 : listResponse.items) {
                            setList(listResponse);
                        }
                        if (typeof window !== 'undefined' && window.__IOMART_DEBUG_LIST__) {
                            console.log('[loadList:done]', {
                                storageName: storageName,
                                category: category,
                                page: paging === null || paging === void 0 ? void 0 : paging.page,
                                itemsAfter: (_d = listResponse === null || listResponse === void 0 ? void 0 : listResponse.items) === null || _d === void 0 ? void 0 : _d.length,
                            });
                        }
                        setIsLoadingList(false);
                        if (!isInitList) {
                            setIsInitList(true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }, [storageName]);
    actions.unmountItem = createAction(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, setItem, setIsInitItem, setIsLoadingItem, setIsErrorItem, setActions;
        return __generator(this, function (_b) {
            _a = useStorage(storageName), setItem = _a.setItem, setIsInitItem = _a.setIsInitItem, setIsLoadingItem = _a.setIsLoadingItem, setIsErrorItem = _a.setIsErrorItem, setActions = _a.setActions;
            setIsLoadingItem(false);
            setItem(undefined);
            setActions([]);
            setIsInitItem(false);
            setIsErrorItem(false);
            return [2 /*return*/];
        });
    }); }, [storageName]);
    // Load one item
    actions.loadItem = createAction(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, setItem, isInitItem, setIsInitItem, setIsLoadingItem, setIsErrorItem, oneItem, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = useStorage(storageName), setItem = _a.setItem, isInitItem = _a.isInitItem, setIsInitItem = _a.setIsInitItem, setIsLoadingItem = _a.setIsLoadingItem, setIsErrorItem = _a.setIsErrorItem;
                    setIsLoadingItem(true);
                    setIsErrorItem(false);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getItem(id)];
                case 2:
                    oneItem = _b.sent();
                    if (oneItem) {
                        setItem(oneItem);
                    }
                    else {
                        console.error('[loadItem] Empty response for id:', id);
                        setIsErrorItem(true);
                    }
                    if (!isInitItem) {
                        setIsInitItem(true);
                    }
                    return [2 /*return*/, oneItem];
                case 3:
                    error_1 = _b.sent();
                    console.error('[loadItem] Failed to load item id:', id, error_1);
                    setIsErrorItem(true);
                    return [2 /*return*/, undefined];
                case 4:
                    setIsLoadingItem(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [storageName]);
    // Actions for items
    actions.loadActions = createAction(function (ids) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, setActions, setIsLoadingActions, actions;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = useStorage(storageName), setActions = _a.setActions, setIsLoadingActions = _a.setIsLoadingActions;
                    setIsLoadingActions(true);
                    return [4 /*yield*/, getActions(ids)];
                case 1:
                    actions = _b.sent();
                    if (actions) {
                        setActions(actions);
                    }
                    setIsLoadingActions(false);
                    return [2 /*return*/];
            }
        });
    }); }, [storageName]);
    // Add one item
    actions.createItem = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var item;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    item = client.all;
                    if (res === null || res === void 0 ? void 0 : res.item) {
                        item = __assign(__assign({}, client.all), res.item);
                    }
                    return [4 /*yield*/, client.mutation((_a = {},
                            _a[c.create] = __assign(__assign({}, item), { __args: { data: data } }),
                            _a))];
                case 1: return [2 /*return*/, (_b.sent())[c.create]];
            }
        });
    }); };
    // Import items
    actions.importItems = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var item;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    item = client.all;
                    return [4 /*yield*/, client.mutation((_a = {},
                            _a[c.import] = __assign(__assign({}, item), { __args: { data: data } }),
                            _a))];
                case 1: 
                // if (res?.item) {
                //   item = {
                //     ...client.all,
                //     ...res.item,
                //   };
                // }
                return [2 /*return*/, (_b.sent())[c.import]];
            }
        });
    }); };
    // Patch one item
    actions.updateItem = createAction(function (id, data) { return __awaiter(void 0, void 0, void 0, function () {
        var setIsLoadingItem, oneItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingItem = useStorage(storageName).setIsLoadingItem;
                    id = Number(id);
                    setIsLoadingItem(true);
                    return [4 /*yield*/, updateItem(id, data)];
                case 1:
                    oneItem = _a.sent();
                    setIsLoadingItem(false);
                    return [2 /*return*/, oneItem];
            }
        });
    }); }, [storageName]);
    // LifeCycle for items or item
    actions.lc = createAction(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (ids, action, isItem, definedFilters, data) {
            var _a, setIsLoadingItem, setIsLoadingList, result, succeedId, result;
            if (ids === void 0) { ids = []; }
            if (isItem === void 0) { isItem = false; }
            if (definedFilters === void 0) { definedFilters = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = useStorage(storageName), setIsLoadingItem = _a.setIsLoadingItem, setIsLoadingList = _a.setIsLoadingList;
                        if (!isItem) return [3 /*break*/, 4];
                        setIsLoadingItem(true);
                        return [4 /*yield*/, getLc(ids, action, data)];
                    case 1:
                        result = _b.sent();
                        if (!(result.count === 1 && result.succeed && action !== "delete")) return [3 /*break*/, 3];
                        succeedId = result.succeed[0];
                        if (!succeedId) return [3 /*break*/, 3];
                        return [4 /*yield*/, actions.loadItem(succeedId)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        setIsLoadingItem(false);
                        return [2 /*return*/, result];
                    case 4:
                        setIsLoadingList(true);
                        return [4 /*yield*/, getLc(ids, action, data)];
                    case 5:
                        result = _b.sent();
                        return [4 /*yield*/, actions.loadList(definedFilters)];
                    case 6:
                        _b.sent();
                        setIsLoadingList(false);
                        return [2 /*return*/, result];
                }
            });
        });
    }, [storageName]);
    actions.setFilterHistory = createAction(function (value) {
        var _a = useStorage(storageName), filterHistory = _a.filterHistory, setFilterHistory = _a.setFilterHistory;
        if (value && !filterHistory.includes(value) && value.length >= 3) {
            setFilterHistory(__spreadArray([value], filterHistory, true));
        }
    });
    return actions;
};
